import React from 'react';
import { observer } from 'mobx-react';
import { Trail, config } from 'react-spring';

import analytics from 'js/services/Analytics';
import { lightGrey1Color, startAnimation, endAnimation } from 'js/config/style';
import { makeRequest } from 'js/services/Network';

import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';

import PageTitle from './PageTitle';
import UserDetails from './UserDetails';
import ReceivingAccount from './ReceivingAccount';
import BillingInformation from './BillingInformation';

const controlPanels = {
  userDetails: UserDetails,
  receivingAccount: ReceivingAccount,
  // billingInformation: BillingInformation,
};

const offset = '6.75rem';

@observer
export default class MyAccountPage extends PageComponent {
  pageName = 'MyAccountPage';
  loginRequired = true;
  pageColor = lightGrey1Color;

  bootstrap = () => {
    const request = makeRequest('my-account-data');
    request.then(response => {
      if(response.data.billingInformation &&
        response.data.billingInformation.address &&
        !response.data.billingInformation.address.formatted_address
      ){
        response.data.billingInformation.address = {};
      }
      this.pageData = response.data
    });
    //analytics.page(this.pageName);
    return request;
  };

  renderPage() {
    return (
      <AppContent>
        <Backdrop offset={offset}>
          <Constraint>
            <PageTitle>My account</PageTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset={offset}>
          <Trail
            native
            items={Object.keys(controlPanels)}
            from={startAnimation}
            to={endAnimation}
            config={config.gentle}>
            {controlPanel => animation => {
              const ControlPanel = controlPanels[controlPanel];
              return <ControlPanel state={this.pageData[controlPanel]} animation={animation} />;
            }}
          </Trail>
        </Constraint>
      </AppContent>
    );
  }
}
